<template>
  <div>
    <el-dialog  title="摄像头配置" :visible.sync="dialogTableVisible">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px" class="demo-ruleForm">
        <el-form-item label="IP地址" prop="ip">
          <el-input type="text" v-model="form.ip" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="摄像头端口" prop="port">
          <el-input type="text" v-model="form.port" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="用户名" prop="userName">
          <el-input type="text" v-model="form.userName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="pwd">
          <el-input type="password" v-model="form.pwd" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submit">提交</el-button>
          <el-button type="primary">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
  import {addCamera } from '@/api/equip.js'
  export default {
    name:'Camera',
    props:['landId'],
    data() {
      return {
        form:{
          ip:undefined,
          port:'',
          pwd:'',
          userName:'',
          landId:this.landId
        },
        dialogTableVisible:false,
        rules: {
          ip: [
            { required: true, message: '请输入IP地址', trigger: 'blur' },
          ],
          port: [
            { required: true, message: '请输入端口号', trigger: 'blur' },
          ],
          pwd: [
            { required: true, message: '请输入密码', trigger: 'blur' },
          ],
          userName: [
            { required: true, message: '请输入用户名', trigger: 'blur' },
          ],
        }
      }
    },
    mounted() {
    },
    methods:{
      submit() {
        this.$refs.form.validate(valid=>{
          if(valid){
            addCamera(this.form).then(data=>{
              this.$emit('cameraGet')
              this.dialogTableVisible=false
            })
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/resource/equip/Camera.vue